import bali from "../../assets/images/bali.jpg";
import singapore from '../../assets/images/singapore.jpg'
import abu from '../../assets/images/abu-dhabi.jpg'
import srilanka from "../../assets/images/srilanka.jpg";
import bhutan from "../../assets/images/bhutan.jpg";
import Vietnam from "../../assets/images/Vietnam.jpg";
import Malaysia from "../../assets/images/Malaysia.jpg";
import Nepal from "../../assets/images/Nepal.jpg";

import bali1 from '../../assets/images/IntImg/Bali 1.jpg'
import bali2 from '../../assets/images/IntImg/Bali 2.jpg'
import bali3 from '../../assets/images/IntImg/Bali 3.jpg'
import bali4 from '../../assets/images/IntImg/Bali 4.jpg'
import bali5 from '../../assets/images/IntImg/Bali 5.jpg'
import bali6 from '../../assets/images/IntImg/Bali 6.jpg'
import bali7 from '../../assets/images/IntImg/Bali 7.jpg'


import singapore1 from '../../assets/images/IntImg/Singapore 1.jpg'
import singapore2 from '../../assets/images/IntImg/Singapore  2.jpg'
import singapore3 from '../../assets/images/IntImg/Singapore  3.jpg'
import singapore4 from '../../assets/images/IntImg/Singapore  4.jpg'
import singapore5 from '../../assets/images/IntImg/Singapore  5.jpg'

import srilanka1 from '../../assets/images/IntImg/Sri Lanka 1.jpg'
import srilanka2 from '../../assets/images/IntImg/Sri Lanka 2.jpg'
import srilanka3 from '../../assets/images/IntImg/Sri Lanka 3.jpg'
import srilanka4 from '../../assets/images/IntImg/Sri Lanka 4.jpg'
import srilanka5 from '../../assets/images/IntImg/Sri Lanka 5.jpg'

import bhutan1 from '../../assets/images/IntImg/Bhutan 1.jpg'
import bhutan2 from '../../assets/images/IntImg/Bhutan 2.jpg'
import bhutan3 from '../../assets/images/IntImg/Bhutan 3.jpg'
import bhutan4 from '../../assets/images/IntImg/Bhutan  4.jpg'
import bhutan5 from '../../assets/images/IntImg/Bhutan 5.jpg'

import Vietnam1 from '../../assets/images/IntImg/Vietnam 1.jpg'
import Vietnam2 from '../../assets/images/IntImg/Vietnam 2.jpg'
import Vietnam3 from '../../assets/images/IntImg/Vietnam 3.jpg'
import Vietnam4 from '../../assets/images/IntImg/Vietnam 4.jpg'
import Vietnam5 from '../../assets/images/IntImg/Vietnam 5.jpg'


import dubai from '../../assets/images/IntImg/Dubai 2.jpg'
import dubai1 from '../../assets/images/IntImg/Dubai 3.jpg'
import dubai2 from '../../assets/images/IntImg/Dubai 4.jpg'
import dubai3 from '../../assets/images/IntImg/Dubai 5.jpg'


import malaysia1 from '../../assets/images/IntImg/Malaysia 1.jpg'
import malaysia2 from '../../assets/images/IntImg/Malaysia 2.jpg'
import malaysia3 from '../../assets/images/IntImg/Malaysia 3.jpg'
import malaysia4 from '../../assets/images/IntImg/Malaysia 4.jpg'
import malaysia5 from '../../assets/images/IntImg/Malaysia 5.jpg'


export const IntPackageData = [
  {
    img: bali,
    country: "Indonesia",
    place: "Bali",
    tripDur: "4 Nights/5 Days Itinerary",
    title: "The Bali Diaries: A Tale of Friendship, Freedom, and Femme Power",
    subDesc:"Tina, Shilpa, and Kavya—three friends bound by laughter, secrets, and a shared craving for adventure—decided it was time. Time to hit pause on life's endless to-dos and hit play on the symphony of the sea, sunsets, and their laughter.",
    imgs:[bali,bali1,bali2,bali3,bali4,bali5,bali6,bali7],
    days: [
      {
        title: "Day 1: Arrival in Bali",
        desc: ["•	Land at Ngurah Rai International Airport" ,"•	Hotel check-in and leisure time" ],
      },
      {
        title: "Day 2: Waterfall & Ubud Tour",
        desc:["•	Explore Batubulan Batik Center, Celuk & Mas" , "•	Visit Tegenungan Waterfall, Tampak Siring Temple, Bali Coffee Plantation" , "•	Lunch at Kintamani with Mount Batur view" , "•	Stroll through Ubud’s Tegalalang Rice Terraces"] ,
      },
      {
        title: "Day 3: Bedugul & Tanah Lot Sunset Tour",
        desc: ["•	Visit Taman Ayun Temple, traditional fruit market, and Ulun Danu Temple" , "•	Stop at Alas Kedaton Monkey Forest" , "•	Catch the sunset at Tanah Lot"],
      },
      {
        title:
          "Day 4: Nusa Dua & Southern Bali Tour",
        desc: ["•	Fun watersports and a banana boat ride at Tanjung Benoa" ,"•	Visit Pandawa Beach and Uluwatu Temple" , "•	End with a BBQ seafood dinner at Jimbaran Bay "],
      },
      {
        title: "Day 5: Departure",
        desc: ["Free time for shopping or relaxing before airport transfer."],
      },
    ],
    days1: [
      {
        title: "Day 1: A Warm Balinese Welcome",
        desc: `The trio touched down at Ngurah Rai International Airport, greeted by a sea of welcoming smiles and vibrant energy.
Tina quipped, "Ladies, this is it—the beginning of our legendary Bali chapter!"
Kavya added with a grin, "Let the 'Eat, Pray, Slay' vibes begin."
Settling into their hotel, they lounged, flipping through plans for the days ahead, each silently relishing the promise of freedom.
`,
      },
      {
        title: "Day 2: Cascades, Coffee, and Creative Chaos",
        desc: `The morning began with a swirl of colors at Batubulan Batik Center. Shilpa, ever the artist, marveled, "How do they make patterns this intricate? I need a wardrobe revamp!"
Next stop: Tegenungan Waterfall. Kavya stood in awe. “Can you believe this power? It’s like Mother Nature saying, ‘You’re stronger than you know!’”
At Kintamani, they lunched overlooking Mount Batur, its serene presence inspiring quiet reflection. “This view,” Tina mused, “feels like a reminder to keep climbing, no matter the obstacles.”
The day ended with the lush beauty of Ubud’s rice terraces, their steps weaving through a tapestry of green, laughter bouncing off every stalk.
`,
      },
      {
        title: "Day 3: Temples, Monkeys, and a Sunset to Remember",
        desc: `The women explored Taman Ayun Temple, marveling at its elegance. Tina joked, “If temples could win beauty pageants, this one’s taking the crown.”
At Alas Kedaton Monkey Forest, the cheeky monkeys mirrored their playful spirit. Shilpa’s squeal echoed, "This monkey and I are practically twins—look at this hair!"
But nothing could prepare them for the golden hues of the sunset at Tanah Lot. Kavya whispered, "If sunsets had a voice, it would be singing freedom.”`,
      },
      {
        title:
          "Day 4: Waves, Rides, and Rooftop Dreams",
        desc: `The ocean called, and the women answered with a splash! The banana boat ride was a symphony of shrieks and giggles as the waves tested their balance.
Pandawa Beach felt like a hidden sanctuary. As they lounged on its pristine sands, Tina declared, “Let’s make a pact—one girls' trip every year, no excuses!”
Dinner at Jimbaran Bay was a feast by the sea, the aroma of BBQ seafood mingling with tales of their adventures. Kavya raised her glass. “Here’s to us—bold, beautiful, and brave!”
`,
      },
      {
        title: "Day 5: Until We Meet Again",
        desc: `The final morning was bittersweet. Packing their bags, Shilpa sighed, “Bali, you’ve spoiled us for life.”
At the airport, Tina smiled, “We came for an escape but left with more—a bond deeper, laughs louder, and memories brighter.”
As their plane took off, the trio looked out at the receding island, a silent promise in their hearts: Bali was only the beginning.`,
      },
    ],
  },
  {
    img: singapore,
    country: "Singapore",
    place: "Singapore",
    tripDur: "4 Nights / 5 Days Singapore Family Itinerary",
    title: "The Singapore Sojourn: A Family Tale of Nature, Freedom, and Fun",
    subDesc:"The Harsha family—comprising Dad Harsha, Mom Vineetha, spirited elder daughter Hiya, and curious little Varun—was embarking on their first international adventure. Singapore, a city of innovation and greenery, was their chosen destination, promising a blend of nature, learning, and unforgettable experiences.",
    imgs:[singapore,singapore1,singapore2,singapore3,singapore4,singapore5],
    days: [
      {
        title: "Day 1: Arrival & City Tour",
        desc: ["•	Guided city tour covering Suntec City, Business District, Chinatown, Orchard, Merlion Park, and Buddha Tooth Relic Temple." , "•	Visit Gardens by the Bay with Cloud Forest Dome, Supertree Observatory, and Light & Sound Show."],
      },
      {
        title: "Day 2: Bird Paradise & Night Safari",
        desc: ["•	Explore Mandai Bird Paradise, home to 5,000+ birds from 400 species." , "•	Experience the thrilling Night Safari to witness nocturnal wildlife."],
      },
      {
        title: "Day 3: Leisure or Optional Excursions",
        desc: ["•	Enjoy a relaxed day or opt for Universal Studios and S.E.A. Aquarium."],
      },
      {
        title: "Day 4: Sentosa Island Adventure",
        desc:["•	Visit Sentosa Island via cable car." , "•	Explore Madame Tussauds 5-in-1 Experience, including Spirit of Singapore and Bollywood Avenue." , "•	End the day with the spectacular Wings of Time Show."] ,
      },
      {
        title: "Day 5: Departure",
        desc: ["•	Morning at leisure before heading to the airport for your flight home."],
      },
    ],
    days1: [
      {
        title: "Day 1: Arrival and Gardens of Dreams",
        desc: `The family touched down in Singapore, greeted by its clean streets and futuristic skyline. A guided city tour introduced them to Suntec City, the bustling Business District, and the iconic Merlion Park. Varun was fascinated by the giant Merlion, declaring it his new favourite "lion-fish."
As the sun dipped, they visited Gardens by the Bay. The Cloud Forest Dome mesmerized Hiya with its cascading indoor waterfall, while the Super tree Observatory offered breathtaking views of a glowing Singapore. The Light & Sound Show left them spellbound, with Varun dancing to the rhythm of the lights.`,
      },
      {
        title: "Day 2: Feathered Friends and Nighttime Adventures",
        desc: `The morning began with a trip to Mandai Bird Paradise. Hiya was enthralled by the vibrant parrots, while Vineetha shared fascinating titbits about the endangered species they encountered. The family marvelled at the immense diversity and left with a newfound respect for avian conservation.
The evening brought a thrilling Night Safari, where the family witnessed nocturnal animals in their natural habitats. Hiya clutched Harsha’s hand as they spotted leopards prowling in the dark, while Varun squealed with delight seeing playful otters.`,
      },
      {
        title: "Day 3: A Day to Unwind or Thrill",
        desc: `While some families might have preferred a relaxed day in Singapore, the Harsha family was ready for an adventure. They opted for the electrifying experience of Universal Studios and dove headfirst into a world of thrill and fantasy.
From the high-octane Transformers 4D ride to the adrenaline-pumping Revenge of the Mummy in the Egyptian zone, every moment was an adventure. Hiya and Varun squealed with joy on the tramp rides, while Vineetha couldn't stop capturing candid family moments with their favourite characters.
Lunch at the quirky Transformers-themed restaurant was the perfect pit stop to refuel before they continued their journey through fantastical worlds. It was a day filled with laughter, bonding, and memories etched forever in their hearts, proving that sometimes, thrills bring families closer together.
`,
      },
      {
        title: "Day 4: Sentosa and Spectacular Evenings",
        desc: `The journey to Sentosa Island began with a scenic cable car ride, leaving Varun wide-eyed and Hiya snapping endless selfies. At Madame Tussauds, they laughed while posing with Bollywood stars and relished the 4D Marvel experience.
But the highlight of the day—and perhaps the trip—was the Wings of Time Show. As the mesmerizing lights danced across the night sky, Harsha whispered, “This trip isn’t just about seeing; it’s about feeling.” Vineetha smiled, knowing her family had bonded even more deeply.`,
      },
      {
        title: "Day 5: Goodbye, Singapore",
        desc: `The last morning in Singapore was bittersweet. Over breakfast, the family reflected on their journey, from the magical gardens to the lively animals and the spectacular shows. Hiya promised to start a project on animal conservation, inspired by the bird park, while Varun declared he wanted to "live in the Merlion."
With their hearts full and memories abundant, they boarded their flight home, forever changed by their Singapore sojourn.
The Harsha family returned not just with photographs but with a renewed love for nature, a deeper understanding of conservation, and countless tales of their shared laughter and joy. For them, Singapore was more than a trip—it was a journey of connection, growth, and freedom.
`,
      },
    ],
  },
  {
    img: srilanka,
    country: "Sri Lanka",
    place: "Sri Lanka",
    tripDur: "7 Nights, and 8 Days in Sri Lanka",
    title: "Sacred Sojourn: A Journey Through the Arupadai Veedu Temples",
    subDesc:"",
    imgs:[srilanka,srilanka1,srilanka2,srilanka3,srilanka4,srilanka5],
    days1: [
      {
        title: "Day 1: Negombo",
        desc: `•	Vinay (to Amit): “Amit, this lagoon ride is surreal! Did you know these catamarans date back centuries?”
•	Meera (to Aarushi): “Look at the fishing nets, Aarushi. These methods are a part of Sri Lanka’s heritage!”
•	Aryan and Arnav (shouting): “Race you to that canoe, Aarushi!”
•	Grandpa Peter chuckles, his laughter blending with the ocean breeze, while Shalini snaps candid photos of the kids.
`      },
      {
        title: "Day 2: Pinnawela Elephant Orphanage",
        desc: `•	Priya (to the group): “Look at them play! Elephants really are the gentle giants of nature.”
•	David: “This would make a perfect sketch for my gallery. The bond between the baby and the caretaker is heartwarming.”
•	Aarushi hands Aryan a handful of bananas for the elephants. The twins grin mischievously before pretending to feed each other instead.
`,
      },
      {
        title: "Day 3: Kandy",
        desc: `At the Temple of the Tooth Relic:
•	Shalini: “This place feels so serene. Imagine the stories these walls could tell.”
•	Vinay: “Speaking of stories, the Gem Museum is our next stop. Anyone up for some sparkling souvenirs?”
•	Grandpa Peter buys Aarushi and the twins small gem pendants, calling them his "shining stars."
`,
      },
      {
        title: "Day 4: Ramboda Tea Factory & Nuwara Eliya",
        desc: `The families sip freshly brewed tea while enjoying the rolling green hills.
•	Amit: “Best tea I’ve ever had! Vinay, let’s buy some for home.”
•	Meera: “Don’t miss the post office! It looks like a slice of England in the tropics.”
•	The kids run around the gardens, playing a game of hide-and-seek while Shalini captures the misty hills for her travelogue.
`,
      },
      {
        title: "Day 5: Seetha Eliya & Haggala Gardens",
        desc: `•	Priya (to the kids): “This temple is part of the Ramayana. It’s said Sita was held captive here!”
•	Aryan: “Can we act it out? Aarushi can be Sita, and Arnav and I will be Hanuman!”
•	The families laugh as David sketches the temple, inspired by the kids’ lively enactment.
`,
      },
      {
        title: "Day 6: Ella",
        desc: `The Nine Arch Bridge becomes a highlight.
•	Grandpa Peter: “Walking across this bridge is like stepping into a postcard.”
•	Shalini (to David): “Hold this angle! I want the boys jumping with the bridge in the background.”
At Ravana Falls, the kids splash in the shallow pools, while Amit organizes a spontaneous picnic.
`,
      },
      {
        title: "Day 7: Colombo",
        desc: `Shopping at Galle Face Green:
•	Meera: “Vinay, how about a family photo by the Twin Towers?”
•	Amit (with bags in hand): “Only if we can stop for ice cream afterward!”
The day ends with a sunset walk along the beach, where Aryan and Arnav fly kites with Grandpa Peter.
`
      },
      {
        title: "Day 8: Departure",
        desc: `As they bid farewell at the airport, Aryan hugs Grandpa Peter.
•	Aryan: “Can we do this again next year, Dadu?”
•	Grandpa Peter: “Absolutely, my boy. This is just the beginning of our adventures.”
The three families leave Sri Lanka, their hearts full of memories and laughter, already planning their next journey with Travelance.
`,
      },
    ],
    days: [
      {
        title: "DAY 1 -: Pick Up from Bandaranaike International Airport and transfer to Negombo",
        desc: ["• Arrival in Negombo - Explore the fishing town and lagoon life."]      },
      {
        title: "DAY 2: Negombo - Kandy",
        desc: ["• Negombo to Kandy - Pinnawela Elephant Orphanage en route."]      },
      {
        title: "DAY 03: Kandy ",
        desc: ["• Kandy City Tour - Sacred Temple of the Tooth Relic and Gem Museum."]      },
      {
        title: "DAY 04: Kandy - Nuwara Eliya",
        desc: ["• Kandy to Nuwara Eliya - Ramboda Tea Factory and hill country charm."]      },
      {
        title: "DAY 05: Nuwara Eliya ",
        desc:["• Nuwara Eliya - Seetha Eliya Temple and Haggala Gardens."]      },
      {
        title: "DAY 06: Nuwareliya-Ella ",
        desc: ["• Nuwara Eliya to Ella - Ravana Waterfalls, Nine Arch Bridge, and Little Adam’s Peak."]      },
      {
        title: "DAY 07:Ella – Colombo ",
        desc:["• Ella to Colombo - Vibrant city tour with shopping and leisure."] },
      {
        title: "Day 8: ",
        desc: ["• Departure from Colombo - Time to bid farewell."]      },
    ],
  },
  {
    img: bhutan,
    country: "Bhutan",
    place: "Bhutan",
    tripDur: "04 Nights and 05 Days ",
    title: "Glimpses of Kerala: A Journey of Reconnection",
    subDesc:"",
    imgs:[bhutan,bhutan1,bhutan2,bhutan3,bhutan4,bhutan5],
    days: [
      {
        title: "Day 1 : PARO AIRPORT TO THIMPHU",
        desc: 
[        `Arrive at Paro Airport, then completing our immigration we will processed to Thimpu Hotel and Overnight stay Thimpu.`
]      },
      {
        title: "Day 2: THIMPHU SIGHTSEEING",
        desc: [`The day will start with a visit to Memorial Chorten, which is built in memory of the Third King of Bhutan. After that, we will cover Nunnery Temple, and Mini Zoo to see Bhutan’s National Animal – Takin. Next, there will be other Landmarks also which we will cover. A few of them are National Library, Handicraft Emporium, Buddha Art Galary, Clock Tower, NITM (National Institute of Traditional Medicine), the Folk Heritage Museum, the Traditional Painting School, the Majestic Tashichho Dzong, and finally the Traditional Paper Factory. Keep in mind few of these places are closed on the Weekends. So, if we are in Thimphu during the Weekends, we will make sure to complement those days with a visit to the Weekend
Market of Thimphu. Finally, Overnight stay at Thimphu.`]      },
      {
        title: "Day 3: THIMPHU TO PUNAKHA",
        desc: 
[        `After Breakfast is done, we will start the day with a journey to Punakha via Dochu La Pass (Height – 3,100 Meters). While the Day is clear, we will be able to get a spectacular view of the Himalayas from the Pass itself. After that, we will come downhill through the Rhododendron, Fir, and Hemlock Forests. Then we will visit Punakha Dzong. Finally, we will check in at the Hotel and after resting for a while, we will take you to the Local Evening Market of Punakha. Overnight stay at Punakha.`
]      },
      {
        title: "Day 4: PUNAKHA TO PARO",
        desc: [`After having breakfast at Punakha Hotel, we will start the day with a 4-5 hours journey to Paro via Punakha
Suspension Bridge, Chimi Lhakhang, International Airport, Nizam Bridge and hence in the evening, we will break our leisure with a visit to the Local Market. Overnight stay at Paro.
`]
      },
      {
        title: "Day 5: PARO SIGHTSEEING",
        desc: 
[        `We will start the day with a visit to Dungtse Lhakhang. After that, we will move to Ta-dzong-now, which is now known as the National Museum and holds fascinating glories of the Bhutanese region. Next, we will go to Rinpung Dzong, which is the Administrative Office. Then we visit Kyichu Lhakhang, Tiger Nest or Ttakshang Monastery and Chelela Pass. Finally, in the evening we will roam around Local Bazar. Overnight stay at Paro.`,
]      },
      {
        title: "Day 5: PARO TO PARO AIRPORT",
        desc:[ `Early Morning 4.00am we will depart for Paro Airport . with a memorable experience of the tour conducted by
Singdha Srijon Tours Private Limited. We hope we will meet again as soon as possible.`],
      },
    ],
  },
  {
    img: Vietnam,
    country: "Vietnam",
    place: "Vietnam",
    tripDur: "05Days/04Nights",
    title:"",
    subDesc:"",
    imgs:[Vietnam,Vietnam1,Vietnam2,Vietnam3,Vietnam4,Vietnam5],
    days: [
      {
        title: "DAY 01: HANOI ARIVAL",
        desc: [`Arrive at Noi Bai International Airport, welcome by our guide and transfer to your hotel. The transfer distance is approximately 40 munites. Check in at hotel. Hanoi or “River-bound City” as its name literally means is Vietnam’s capital with a thousand-year-old history dating back to 1010. The city’s fascinating beauty which is characterized by unique cultural relics,
ancient streets of antique houses, elegant French colonial buildings, tree-lined boulevards and romantic lakes has made it one of the most charming cities of Asia.
Meals: No`]
      },
      {
        title: "DAY 02 HANOI FULL DAY CITY TOUR (B)",
        desc: 
[        `Today after breakfast, proceed to full day city tour. Visit the Ho Chi Minh Complex (Ho Chi Minh Mausoleum, Ho Chi Minh Museum and One pillar pagoda) and the Tran Quoc Pagoda. Continue to the Temple of Literature, the first University in Vietnam dating back to the 16th century. In the afternoon, enjoy a cyclo tour through the Old Quarter will provide another fascinating insight into the character and history of the city, before moving on to Dong Xuan Market with its bustling stalls and brisk trading of day-to-day local goods. Overnight stay in Hanoi. Meals: Breakfast`
]      },
      {
        title: "DAY 03: HANOI – HALONG BAY IN SHUTTLE BUS (B/L/D)",
        desc: [`In the morning, shuttle bus will pick you up from your hotel for transfer to Ha Long Bay, which is about 160 km or 3.5-hour drive away. On the way, you will see some rural areas of the Red River Delta with plenty of chances to take photos of Vietnamese farmers working in paddy fields. Stop half way to visit a handicraft workshop of fine clothes and embroidered paintings.
Arrive at the jetty in Ha Long City towards noon and proceed with check-in formalities. Be welcomed onboard and have lunch will be served while cruising towards the bay itself. In the afternoon, enjoy some visits and/or activities (depending on each boat’s itinerary) or just spend some time relaxing on board. Towards the end of the day the boat sets anchor for the night among the karst formations. Dinner is served on board. Overnight on
Ha Long Bay.
Meals: Breakfast, Lunch, Dinner
Accommodation: overnight on cruise in Ha Long bay`]
      },
      {
        title: "DAY 04: HA LONG – HANOI IN SHUTTLE BUS (B/L)",
        desc: [`Today enjoy the fresh morning in the middle of the bay, the sun rises on Ha Long in the morning and breakfast is served (brunch on some boats) while the vessels cruise slowly through the magnificent rock formations and back towards port. Disembark and transfer back to Hanoi. Overnight stay in Hanoi.
Meals: Breakfast, Lunch`]
      },
      {
        title: "DAY 05: HANOI – DEPARTURE (B)",
        desc: [`Free at leisure before transfering to airport for departure flight.
Meals: Breakfast`],
      },
      
    ],
  },
  {
    img: abu,
    country: "United Arab Emirates (UAE)",
    place: "Dubai",
    tripDur: "4 Nights | 5 Days",
    title:"A Tale of Two Families in Dubai: Bonding, Laughter, and Unforgettable Adventures",
    subDesc:"Two families—Parents Anand & Priya with kids Yashitha & Ananya, along with Parents Arun & Kavitha with son Pranav—embarked on a memorable journey to Dubai, a destination known for its blend of modern marvels and rich traditions. Though strangers at first, their shared experiences in the golden city fostered a deep and lasting friendship.",
    imgs:[abu,dubai,dubai1,dubai2,dubai3],
    days: [
      {
        title: "Day 1: Arrival – Marina Cruise.",
        desc: ["•	Airport pickup and hotel check-in." , "•	Evening Marina Cruise with scenic views and a relaxed ambience."]
      },
      {
        title: "Day 2: Dubai City Tour – Dubai Mall – Burj Khalifa",
        desc: ["•	Visit Dubai’s landmarks: Jumeirah Mosque, Dubai Museum, and scenic attractions." , 
          "•	Explore Dubai Mall for shopping and entertainment.",
          "•	At the Top experience at Burj Khalifa and witness the fountain show."
        ]
      },
      {
        title: "Day 3: Desert Safari",
        desc: ["•	Thrilling dune bashing, camel rides, sandboarding, and cultural shows." , "•	BBQ dinner under the stars."],
      },
      {
        title: "Day 04: Abu Dhabi City Tour – Grand Mosque",
        desc:["•	Visit Abu Dhabi’s landmarks and explore Sheikh Zayed Grand Mosque."],
      },
      {
        title: "Day 05: Departure",
        desc: [`Morning at leisure before heading to the airport.`],
      },
    ],
    days1: [
      {
        title: "Day 1: A Grand Welcome and Magical Marina Cruise",
        desc: `Upon arriving at Dubai Airport, the families were greeted warmly by their tour representative and whisked off to their hotel. The children, especially Pranav and Ananya, couldn’t wait to jump on the soft beds, while the parents admired the luxurious hospitality.
In the evening, the two families met on the Marina Cruise. With moonlight shimmering on the calm waters and the Dubai skyline dazzling in the background, they shared their first laughs. While the adults enjoyed the serene ambience, the kids bonded over their shared excitement for the days ahead. Yashitha, the elder sibling, clicked selfies with Pranav and Ananya as they posed with mocktails in hand.`,
      },
      {
        title: "Day 2: Exploring Dubai and Its Towering Beauty",
        desc: `The city tour began with Anand and Arun joking about who could outdo the other in taking pictures. The families marvelled at the Jumeirah Mosque, Dubai Museum, where Ananya couldn’t stop giggling at Pranav’s attempts to mimic the tour guide. The day reached its peak (literally) when they ascended the Burj Khalifa. The panoramic view left everyone awestruck. “I feel like a bird,” Ananya exclaimed, while Pranav pretended to fly, making everyone laugh.
At Dubai Mall, the younger ones were fascinated by the aquarium and the ice rink, while the mothers explored designer stores. By the evening, the families watched the dazzling fountain show together, capturing the magical moments to cherish forever.`
      },
      {
        title: "Day 3: Fun and Frolic in the Desert",
        desc: `The Desert Safari was the highlight of their trip. Pranav, usually the bravest, froze in terror when a majestic eagle was brought out for a falconry demonstration. “Don’t let it peck me!” he squealed, hiding behind Yashitha. The adults roared with laughter, and even the usually shy Ananya couldn’t stop giggling.
Dressed in traditional Arabian attire, the families looked like they had stepped out of an ancient tale. Anand and Arun jokingly declared themselves sheikhs, while the kids enjoyed camel rides and tried sandboarding. Dinner under the starlit sky, with the rhythm of cultural performances in the background, was a magical end to the adventurous day.`,
      },
      {
        title: "Day 4: Abu Dhabi’s Grandeur and Togetherness",
        desc: `An early morning drive to Abu Dhabi brought new adventures. The Sheikh Zayed Grand Mosque left everyone speechless with its grandeur. Priya and Kavitha found a moment of peace as they admired the intricate details, while the kids marvelled at the giant chandeliers.
The families spent the afternoon exploring Abu Dhabi’s landmarks, laughing and sharing stories. By now, the bond between the two families had grown strong. The fathers planned a group photo session, while the mothers shared travel tips and recipes.`,
      },
      {
        title: "Day 5: Farewell, But Not Goodbye",
        desc: `On the final day, as they packed their bags, there was a bittersweet feeling. The journey had brought them closer, creating memories that would last a lifetime.
At the airport, the kids exchanged small souvenirs, promising to meet again. Anand and Arun shook hands warmly, and Priya and Kavitha shared a heartfelt hug, bidding goodbye to a trip that was not just about a destination but about forging friendships that would endure the test of time.
`,
      },
    ],
  },
  {
    img: Malaysia,
    country: "Malaysia ",
    place: "Malaysia",
    tripDur: "4 Nights / 5 Days",
    title:"A Tale of Connection: When Travel Became the Common Thread",
    subDesc:`Amid the fast-paced lives of a close-knit group of friends and family, the idea of connecting over a shared experience sparked the perfect plan: a trip to Malaysia. The itinerary was a blend of heartwarming reunions and vibrant exploration, making it an unforgettable adventure where every journey touched every life.
Their journey began with a heartfelt reunion in Kuala Lumpur, where they visited family who had settled in Malaysia years ago. Stories of adaptation, success, and nostalgia filled the air during their stay. Inspired by their hosts’ tales of Malaysia’s stunning diversity, they embarked on a 4 Nights/5 Days Kuala Lumpur and Langkawi Tour Package, a meticulously planned adventure.`,
    imgs:[Malaysia,malaysia1,malaysia2,malaysia3,malaysia4,malaysia5],
    days: [
      {
        title: "Day 1:",
        desc: ["• Arrive in Langkawi, enjoy panoramic views from the Langkawi Cable Car, and interact with wildlife at the Langkawi Wildlife Park."],
      },
      {
        title: "Day 2: Pantai Cenang Beach - Paradise 3D Museum - Telaga Tujuh Waterfalls.",
        desc: ["• Relax at Pantai Cenang Beach, explore the Paradise 3D Museum, and marvel at the Telaga Tujuh Waterfalls."]      },
      {
        title: "Day 3: Reach Kuala Lumpur - Malacca - Petronas Twin Towers",
        desc:["• Fly to Kuala Lumpur, visit the historic Malacca (a UNESCO site), and witness the iconic Petronas Twin Towers."]      },
      {
        title: "Day 4: KL Bird Park - Batu Caves - National Mosque of Malaysia",
        desc: ["• Discover the serenity of Batu Caves, the architectural splendor of the National Mosque, and the vibrant KL Bird Park."]      },
      {
        title: "Day 5: Depart from Kuala Lumpur",
        desc: ["• Depart from Kuala Lumpur with unforgettable memories."],
      },
    ],
    days1: [
      {
        title: "Day 1: Arriving in Langkawi – A Soaring Start",
        desc: `Upon arrival in Langkawi, they were greeted warmly and checked into a cozy hotel. The Langkawi Cable Car set the tone for the trip, taking them 650 meters above sea level to a breathtaking view of the island. Later, at the Langkawi Wildlife Park, laughter echoed as everyone interacted with over 150 animal species, making new memories that would last a lifetime.`,
      },
      {
        title: "Day 2: Beaches, Art, and Nature",
        desc: "Relaxation met adventure at Pantai Cenang Beach, where the group enjoyed the azure waters and sampled local cuisine. The creative souls in the group marveled at the vibrant displays of the Paradise 3D Museum, the second-largest 3D museum in the world. The day ended with awe-inspiring sights at the Telaga Tujuh Waterfalls, where cascading waters amidst lush greenery felt like nature’s embrace.",
      },
      {
        title: "Day 3: From Langkawi to Kuala Lumpur – Heritage and Icons",
        desc: "A short flight took them to Kuala Lumpur, where history came alive in the UNESCO World Heritage Site of Malacca. Tales of trade, colonial influence, and vibrant culture enriched their journey. The day ended with a visit to the iconic Petronas Twin Towers, a symbol of modern Malaysia and the perfect backdrop for family photos.",
      },
      {
        title: "Day 4: Spirituality and Serenity",
        desc: "The day began with a spiritual ascent to the Batu Caves, where the towering golden statue and limestone formations left everyone awestruck. The tranquil beauty of the National Mosque of Malaysia offered a moment of reflection. The day closed at the Kuala Lumpur Bird Park, where they delighted in the colorful sights and sounds of over 3,000 birds.",
      },
      {
        title: "Day 5: Departing with Full Hearts",
        desc: "As they packed up for their flight home, the group reflected on the laughter, shared meals, and deep conversations that had made this trip unforgettable.",
      },
      {
        title: "Every Journey Leaves a Mark",
        desc: `The Travelance Promise ensured this trip was more than just a vacation—it was a journey of reconnection, growth, and cherished memories. From reuniting with loved ones to exploring the rich culture and natural wonders of Malaysia, the group discovered that travel doesn’t just take you places—it brings you closer to each other.
As they bid farewell to Malaysia, their hearts were full, their bonds stronger, and their spirits uplifted, proving once again that “Every travel touches every life.”`,
      },
    ],
  },
  {
    img: Nepal,
    country: "Nepal",
    place: "Nepal",
    tripDur: "06 Night /07 Days",
    title:"",
    subDesc:"",
    imgs:[Nepal],
    days: [
      {
        title: "Day 01 : Arrive in Kathmandu ",
        desc: 
[        "Upon arrival in Kathmandu Airport, you will be greeted and assisted by our Representative. After completing your custom formalities, transfer to the Hotel for check-in. Afternoon, visit Boudhanath Stupa, Evening, attend Aarati at Pashupatinath Temple. Drive back to Hotel. Overnight at Kathmandu Hotel.",
]      },
      {
        title: "Day 02 : Kathmandu - Pokhara Via manakamana Temple ",
        desc: 
[        "After breakfast, Darshan of Pasupatinath Temple, drive to Pokhara (about 210 km, 6/7 hrs). Enroute visit Manakamana Temple by Cable Car. Continue to drive to Pokhara. Arrive in Pokhara. Transfer to Hotel. Rest of the day is free for stroll around the surrounding area. Overnight at a Hotel in Pokhara. ",
]      },
      {
        title: "Day 03: Pokhara Sunrise & Sightseeing",
        desc:
[         "Early morning 5 Am sunrise and Himalayan view from Sarangkot hill (subject to weather condition). Visit Bindabasini Temple. Drive to the Hotel for breakfast. Later, visit Davis water fall, Gupteshwor Cave, Seti River, and one hour boat ride on Phewa Lake and visit Taal Barahi Temple. Rest of the day is free. Overnight at a Hotel in Pokhara.",
]      },
      {
        title: "Day 04 : Pokhara - Chitwan",
        desc: 
[        "Drive to Chitwan (about 120 km, 4 hrs drive).Arrive in Chitwan. Transfer to Hotel for check –in. Upon arrival, lunch will be served. After that, visit Tharu Village. Evening, sunset and Tharu Stick Dance. Overnight at a Hotel in Chitwan.",
]      },
      {
        title: "Day 05: Chitwan Activities ",
        desc: 
[        "Today, you will enjoy Canoe ride on the Rapti River (Crocodile watching) ,Elephant Breeding Center, Jungle Walk and Elephant bath (during summer season only) then come back for lunch and rest the Evening Elephant Back Safari at National Park. Overnight at a Hotel in Chitwan.",
]      },
      {
        title: "Day 06: Chitwan- Kathmandu ",
        desc: 
[        "After breakfast, back to Kathmandu. Upon arrival in Kathmandu, visit Swoyambhunath Stupa (Monkey Temple). Later, transfer to Hotel for check-in. Overnight is at a Hotel in Kathmandu. ",
]      }, {
        title: "Day 07 : Kathmandu - Departure transfer  ",
        desc: 
[        "After breakfast, the morning will be comparatively free and closer to the time of your flight, you will be transferred to the airport in time to board your flight for onward journey.",
]      },
    ],
  },

//   {
//     img: Chardham,
//     country: "India",
//     place: "Char Dham Yatra",
//     tripDur: "12 Nights 13 Days ",
//     days: [
//       {
//         title: "Day 1: Delhi – Haridwar /Rishikesh (240kms/6-7Hrs):-",
//         desc: `Meet Our Driver At Delhi Airport /Station / Hotel / Home And Drive To Haridwar. Check Into The Hotel Arrival In Haridwar. Evening Visit Mansa Devi Temple & Ganga Aarti At Har Ki Pauri. Overnight Stay At Haridwar.
//  An Evening At Ganga Aarti Haridwar: The Ganga Aarti In Hardwar’s Har-Ki-Pauri Is One Of The Famous Rituals In India. It Starts At Around 6.30pm After Sunset, With Large Crowds Gathered Around Both The Banks Of A Canal That Carries The Waters Of Ganges. Loud Speakers Blare Songs In Praise Of Ganga Maiya And Shiva. The Time Of Aarti Sees A Bustle Of Activity On The Ghats A Pack Of Diya Comes Fully Equipped And Is Self-Sufficient! It Has A Wick Lamp Surrounded By Flowers It Lasted For Around 30 Min.
// `,
//       },
//       {
//         title: "Day 02: Haridwar/Rishikesh - Barkot (210kms/7-8Hrs):- ",
//         desc: "Morning After Breakfast Transfer To Barkot Via Mussoorie. En-Route Visit Mussoorie Lake & Kempty Fall In Mussoorie. Later Drive To Barkot. On Arrival, Check-In At The Hotel In Barkot For Dinner & Overnight Stay.",
//       },
//       {
//         title: "Day 03: Barkot - Yamunotri - Barkot {42kms Drive/5 Kms Trek (One Side)}:-",
//         desc: `Early Morning After Breakfast  Drive To Jankichatti / Phoolchatti & Trek From Here To Yamunotri (6kms) (Either By Walk Or By Horse Or By Doli At Own Cost). After Taking A Bath In Jamunabai Kund’s Warm Water And Cook Rice By Packing It In A Cloth And Dipping It In The Hot Water Of The Hot Kund. Pilgrims Take This Cooked Rice Home As "Prasad". Having Darshan Of “Yamunaji” Return To Jankichatti By Trek. Overnight Stay At Barkot. 
//         Hanuman Chatti: The Confluence Of Hanuman Ganga & Yamuna River. 
// Yamunotri Temple: Maharani Gularia Of Jaipur Built The Temple In The 19th Century. It Was Destroyed Twice In The Present Century And Rebuilt Again. 
// Surya Kund: There Are A Number Of Thermal Springs In The Vicinity Of The Temple, Which Flows Into Numerous Pools. The Most Important Of These Is Surya Kund. 
// Divya Shila: A Rock Pillar, Worshipped Before Entering The Yamunotri Temple.
// Yamunotri- Yamunotri Is Situated In The Western Region Of The Garhwal Himalayas And Is At A Height Of 3,235 Meters Above Sea Level. Yamunotri Is The Source Of The River Yamuna.The Shrine Of Yamunotri Is Located On The Bandar Poonch Peak. 

//         `,
//       },
//       {
//         title: "Day 04: Barkot - Uttarkashi (100 Kms/4Hrs):- ",
//         desc: `Morning After Breakfast,Check Out From Barkot Hotel And Drive To Uttarkashi. Check Into The Hotel Arrival In Uttarkashi. Evening Visit Kashi Vishwanath Temple In Uttarkashi. Overnight Stay And Dinner At Uttarkashi.'
//         Uttarkashi: Situated At The Bank Of River Bhagirathi. The Temple Of Lord Vishwanath Is Located Here Where A Massive Iron Trident Is Erected. The Other Important Temples Situated Here Are Ekadash Rudra, Bhairav, Gyaneshwar And Goddess Kuteti Devi. 
//         `,
//       },
//       {
//         title: "Day 05: Uttarkashi - Gangotri - Uttarkashi (120kms/5 Hrs Each Side):- ",
//         desc: `Early Morning  Drive To Gangotri(3048 Mts), Enroute At Gangnani Take A Holy Dip In Garam Kund, Have Bath Drive To Gangotri Via Beautiful Harsil Valley. Harsil Is Famous For Its Natural Beauty And For The Majestic Views Of The Deodar Trees And Mountains. On Arrival At Shree Gangotri, Take A Holy Dip In The Sacred River Ganges Which Is Also Called Bhagirathi At Its Origin. Perform Pooja And Darshan, After That Relax For Some Time In The Lovely Surroundings. Later Drive Back To Uttarkashi. Overnight Stay And Dinner At Uttarkashi.
//         Gangotri- Gangotri Is The Place High In The Garhwal Himalayas From Where The Holy Ganges Originates. According To The Legend, It Was Here The Ganga Descended On The Earth, When Lord Shiva Released The Mighty River From The Locks Of His Hair. The Temple Of Gangotri, Dedicated To Goddess Ganga Stands On The Banks Of The River
//         `,
//       },
//       {
//         title: "Day 06: Uttarkashi – Guptkashi/Phata (290kms/8-9hrs):-  ",
//         desc: `Morning After Breakfast,Check Out From Uttarkashi Hotel And Drive To Guptkashi Via Moolgarh & Lambgoan. Enroute You Can See The Beautiful River Mandakini At Tilwara. The Mandakini River Comes From Kedarnath, Drive Alongside The River To Reach Guptkashi, Visit Ardhnarishwar Temple In Guptkashi. Check Into The Hotel Arrival In Guptkashi. Overnight Stay And Dinner At Guptakashi.
//         `,
//       },
//       {
//         title: "Day 07: Guptkashi/Phata – Shri Kedarnath Ji {32kms Drive/19kms Trek (One Side)}:-  ",
//         desc: `Morning After Breakfast Drive To Gaurikund, Trek Start From Gaurikund To Shri Kedarnath Ji (3584 Mts) On Foot Or On By Pony / Doli/ Helicopter. Yatra Members Should Carry Personal Medicines, Heavy Woolen, Toiletries And Clothes For An Overnight Halt At Shri Kedarnath. Check In Hotel. After Freshening Up, Visit Shri Kedarnath Ji Temple & Perform Pooja. In The Evening Also Visit Adi Shankaracharya Samadhi Behind The Temple. Overnight Stay At Kedarnath Hotel.
 
// Shri Kedarnath- Is A Majestic Sight, Standing In The Middle Of A Wide Plateau Surrounded By Lofty Snow Covered Peaks. The Temple Of Kedarnath, Located At A Height Of 3,581 Mts, Stand At The Head Of The Mandakini River. The Present Temple, Built In The 8th Century By Adi Shankaracharya, Stands Adjacent To The Site Of An Earlier Temple Built By The Pandavas. The Inner Walls Of The Assembly Hall Are Decorated With Figures Of Various Deities And Scenes From Mythology. Outside The Temple Door A Large Statue Of The Nandi Bull Stands As Guard. It Is Said That Devotees Who Die Here Become One With Shiva Himself. 
// `,
//       },
//       {
//         title: "Day 08: Shri Kedarnath – Guptkashi/Phata {19kms(Trek)/32kms 6hrs:-",
//         desc: `After Breakfast Check Out From Kedarnath Hotel And Again Cross The Kedarnath Trek From Gaurikund Our Cab Will Pick You And Drive Back For Guptkashi . Reach At Guptkashi Hotel And Relax After Long Trekking From Kedarnath To Gaurikund.Check Into The Hotel And Relax.Overnight Stay And Dinner At Guptkashi/Phata Hotel.
// `,
//       },
//       {
//         title: "Day 09: Guptkashi- Joshimath/Badrinath/Pipalkoti(180kms/7Hrs):- ",
//         desc: `Morning After Breakfast, Drive To Shri Badrinath. Check In To The Hotel/. Pilgrims After Having A Bath In The Taptkund Have The Darshan Of  Badrivishal & Aarti In The Evening. Brahma Kapal Is Significant For Pind Daan Shraddh Of Ancestors (Pitrus). Overnight Stay At Shri Badrinath.
 
// Shri Badrinath- Shri Badrinath Is One Of The Most Important Of All The Four(Char) Dhams In India. This Temple Located Between Nar & Narayan Mountain Ranges And In The Shadow Of Nilkantha Peak At The Height Of 3,133 Mts. It Is The Most Popular Of Vishnu Pilgrimages Among The Five Badries, Also Known As Vishal Badri. 
// Tapt Kund: Natural Thermal Springs On The Banks Of The River Alaknanda, Where It Is Customary To Bathe Before Entering The Badrinath Temple. 

// Narad Kund: A Recess In The River, Near Tapt Kund, Forming A Pool From Where The Badrinath Idol Was Recovered. 

// Mata Murty Temple: Devoted To The Mother Of Sri Badrinathji. Other Important Temples Include Seshnetra Temple, Urvashi Temple And Charan Paduka 
// `,
//       },
//       {
//         title: "Day 10: Joshimath/Shri Badrinath/ Pipalkoti - :- ",
//         desc: `Morning After Breakfast,Visit On The Way Narsingh Templle .Visit Day Tour To Auli By Ropeway.(Pay Yourself) Overnight Stay And Dinner At Hotel/jhoshimath/pipalkoti.
// There Are Other Interesting Sightseeing Spots Like Mana, Vyas Gufa, Mata Murti, Charanpaduka, Bhimkund And The “Mukh” Of The Saraswati River. Just Within The Three Kms Of Badrinath Ji.
  
// Narsingh Temple: This Is An Ancient Temple Of Lord Vishnu In Narsingh Avtar And Main Temple Of Joshimath. When Badrinath Temple Remains Closed During Winter Every Year, One Idol Of Lord Badri Is Brought To Narsingh Temple And Worshiped For Six Months. 
 
// Bhim Pul: On The Other Side Of Mana Village, A Massive Rock Forming A Natural Bridge Lies
// Over The Roaring Saraswati River. It Presents A Spectacular View Of Water Thundering Down Through The Narrow Passage Under The Rock And Is Believed To Have Been Placed There By Bhim, The Second Eldest Among The Five Pandava Brothers. 

// Vyas Gufa (Cave): Near Mana Village, This Is A Rock-Cave Where Ved Vyas Is Believed To Have Composed The Mahabharata And The Pauranic Commentaries. 
// `,
//       },
//       {
//         title: "Day 11: Joshimath / Shri Badrinath / Pipalkoti - Haridwar (165kms/5-6hrs):- ",
//         desc: `Morning After Breakfast, Drive For Haridwar Via Rishikesh.Rishikesh’place Of Sages’ Is A Celebrated Spiritual Town On The Bank Of Ganga And Is Surrounded By Shivalik Range Of The Himalayas On Three Sides. It Is Said That When Raibhya Rishi Did Hard Penances, God Appeared By The Name Of ” Hrishikesh ” And This Area Hence Firth Came To Be Known As Rishikesh. Later Visit Rishikeshtemples Sightseeing – Laxmanjhulla, Ram Jhulla. Stay At Haridwar.`,
//       },
//       {
//         title: "Day 12: Haridwar - Delhi (240kms/6-7Hrs):-",
//         desc: `Morning, After Breakfast, Check-Out From The Hotel And Drive Back To Delhi. On Arr. Delhi, Transfer To Railway Station/Airport.`,
//       },

//     ],
//   },
];
